<template>
    <div :class="[
        'cz2__header-bar',
        {
            'cz2__header-bar--with-toast': hasToastMessage,
        }
    ]">
        <button class="cz2__header-bar__close" :aria-label="$t('MENU_CLOSE')" @click.prevent="close">
        </button>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__header-bar {
            position: absolute;

            left: 0px;
            top: 0px;

            transition: top $transition-fast ease-out;

            &.cz2__header-bar--with-toast {
                top: $toast-height;
            }
        }

        .cz2__header-bar__close {
            position: absolute;

            left: 20px;
            top: 20px;

            width: 44px;
            height: 44px;

            z-index: 10;

            &:after {
                content: '';

                display: block;
                position: absolute;

                left: 0;
                top: 0;

                width: 44px;
                height: 44px;

                background: transparent url(../assets/global-close@2x.png) no-repeat center/contain;
            }
        }
    }
</style>

<script>
    export default {
        computed: {
            /**
             * Is design outside of bounds.
             */
            designOutside() {
                return this.$store.state.designOutside;
            },

            /**
             * Is there an active toast message.
             */
            hasToastMessage() {
                if (this.$store.state.toastMessage != null) {
                    return true;
                }

                if (this.designOutside) {
                    return true;
                }

                return false;
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showExitConfirmation', true);
            },
        },
    };
</script>
